module.exports = __webpack_public_path__ + "static/img/02_ykys.985afd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessPlatform/swiperImg/thirdLine/02_ykys.png
// module id = o/oc
// module chunks = 0